// Moglee Base — video play, image comparison, shop the look hotspots.

(function () {
  // Click to play: swaps the poster for the real video or embed.
  document.querySelectorAll('[data-mb-video]').forEach(function (wrapper) {
    var button = wrapper.querySelector('[data-mb-video-play]');
    if (!button) return;

    button.addEventListener('click', function () {
      var embed = wrapper.getAttribute('data-embed');
      var hosted = wrapper.querySelector('video');

      if (hosted) {
        button.remove();
        hosted.setAttribute('controls', 'controls');
        hosted.play();
        return;
      }

      if (embed) {
        var frame = document.createElement('iframe');
        frame.setAttribute('src', embed);
        frame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        frame.setAttribute('allowfullscreen', 'true');
        frame.setAttribute('title', wrapper.getAttribute('data-title') || 'Video');
        wrapper.appendChild(frame);
        button.remove();
      }
    });
  });

  // Before and after slider.
  document.querySelectorAll('[data-mb-compare]').forEach(function (wrapper) {
    var range = wrapper.querySelector('[data-mb-compare-range]');
    if (!range) return;

    function apply() {
      wrapper.style.setProperty('--mb-compare', range.value + '%');
    }

    range.addEventListener('input', apply);
    apply();
  });

  // Shop the look hotspots.
  document.querySelectorAll('[data-mb-look]').forEach(function (look) {
    var spots = look.querySelectorAll('[data-mb-spot]');

    function closeAll(except) {
      spots.forEach(function (spot) {
        if (spot === except) return;
        spot.setAttribute('aria-expanded', 'false');
        var card = look.querySelector('[data-mb-spot-card="' + spot.getAttribute('data-mb-spot') + '"]');
        if (card) card.setAttribute('data-open', 'false');
      });
    }

    spots.forEach(function (spot) {
      spot.addEventListener('click', function () {
        var id = spot.getAttribute('data-mb-spot');
        var card = look.querySelector('[data-mb-spot-card="' + id + '"]');
        var open = spot.getAttribute('aria-expanded') === 'true';
        closeAll(spot);
        spot.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (card) card.setAttribute('data-open', open ? 'false' : 'true');
      });
    });

    document.addEventListener('click', function (event) {
      if (!look.contains(event.target)) closeAll(null);
    });
  });
})();
